import { CheckFill, CircleFill, XmarkFill } from '../../assets';
import { IconSVG } from '../icon';
import './feedback-message.css';
import { FeedbackMessageProps } from './feedback-message.props';

const FeedbackMessage = ({ message, type = 'info' }: FeedbackMessageProps) => {
  return (
    <div className={`feedback-box ${type}`}>
      <div className="feedback-iconL-box">
        {type === 'success' ? (
          <IconSVG Icon={CheckFill} stroke="#ffffff" fill="#ffffff00" />
        ) : type === 'error' ? (
          <IconSVG Icon={XmarkFill} stroke="#ff0000" />
        ) : type === 'info' ? (
          <IconSVG Icon={CircleFill} fill="#000000" />
        ) : (
          <></>
        )}
      </div>
      <p className={`feedback-type ${type}`}>{message}</p>
    </div>
  );
};

export default FeedbackMessage;
